import { TooltipContent } from '@anm/components/Tooltip';
import {
  OptionContainer,
  SelectOptionsContainer,
  SelectValueContainer,
  SelectWrapper
} from '@anm/components/select/Select';
import styled, { css } from 'styled-components';

export type DropdownDirection = 'top' | 'bottom';

type SelectContainerProps = {
  count: number;
  isHovered: boolean;
  isActiveView: boolean;
  dropdownDirection: DropdownDirection;
};

const selectValueHoverStyles = css`
  background: #f5f7fa;
  border-radius: 5px;
`;

const directions: { [key in DropdownDirection]: ReturnType<typeof css> } = {
  top: css`
    top: unset;
    bottom: 60px;

    &:before {
      top: 100%;
    }
  `,
  bottom: css`
    top: 60px;

    &:before {
      top: -10px;
    }
  `
};

const Wrapper = styled.div<SelectContainerProps>`
  ${TooltipContent} {
    left: 10px;
    min-width: 224px;
    transform: unset;
    top: calc(-100% - 15px);
    padding: 16px 20px 13px;
    a {
      color: var(--blue_100);
    }
  }
  ${SelectOptionsContainer} {
    ${({ dropdownDirection }) => directions[dropdownDirection]};

    &:before {
      display: block;
      position: absolute;
      content: '';
      width: 100%;
      height: 10px;
    }

    &:hover,
    div:hover {
      cursor: pointer;
    }
  }
  ${SelectValueContainer} {
    height: 50px;
    color: ${({ isActiveView }) => (isActiveView ? 'var(--blue_100)' : '#919eaa')};
    font-size: 16px;
    line-height: 21px;
    font-weight: normal;
    margin-bottom: 10px;
    ${({ isHovered }) => isHovered && selectValueHoverStyles}
    &:before {
      max-width: 16px;
      margin-right: 12px;
    }
    &:after {
      content: unset;
    }
  }
  ${OptionContainer}, a {
    justify-content: center;
  }
  ${SelectWrapper} {
    opacity: 1;
    cursor: pointer;
  }
`;

export default Wrapper;
